<div class="contentModal">
    <div class="tituloModal">
        <span>
            {{titulo}}
        </span>
        <mat-icon class="buttonClose" [mat-dialog-close]=false>close</mat-icon>
    </div>
    <div class="textModal">
        {{textoConfirmacion}}
    </div>
    <div class="accionModal">
        <div class="buttons">
            <button mat-raised-button class="button cancelar" [mat-dialog-close]=false>Cancelar</button>
            <button mat-raised-button class="button borrar" [mat-dialog-close]=true>{{textoBoton}}</button>
        </div>
    </div>
</div>